import html2canvas from 'html2canvas'

export default async function getWindowScreenshot (document: Document): Promise<Blob> {
    return new Promise(async (resolve, reject) => {
        try {
            const canvas = await html2canvas(document.body, {
                allowTaint: true,
                useCORS: true,
            })

            canvas.toBlob(blob => {
                resolve(blob!)
            })
        } catch (err) {
            reject(err)
        }
    })
}
